import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/clinic/assets/images/logo-recoma.png'


const _withScopeId = n => (_pushScopeId("data-v-5aba301a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "header",
  class: "p-0 flex h-full"
}
const _hoisted_2 = { class: "flex justify-content-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Re;COMa"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex align-content-center justify-content-end flex-wrap header-action" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M921.6 0H102.4C46.08 0 0 46.08 0 102.4v921.6l204.8-204.8h716.8c56.32 0 102.4-46.08 102.4-102.4V102.4c0-56.32-46.08-102.4-102.4-102.4zM204.8 358.4h614.4v102.4H204.8v-102.4zM614.4 614.4H204.8v-102.4h409.6v102.4z m204.8-307.2H204.8v-102.4h614.4v102.4z" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M597.333333 853.333333a85.333333 85.333333 0 0 1-85.333333 85.333334 85.333333 85.333333 0 0 1-85.333333-85.333334h170.666666M512 85.333333a42.666667 42.666667 0 0 1 42.666667 42.666667v46.08c121.173333 20.48 213.333333 125.866667 213.333333 252.586667v256l128 128H128l128-128v-256c0-126.72 92.16-232.106667 213.333333-252.586667V128a42.666667 42.666667 0 0 1 42.666667-42.666667z",
  fill: ""
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "mr-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mr-2 ml-0 mb-0 font-normal text-white modal-title" }, "予約アラート", -1))
const _hoisted_12 = { class: "flex flex-column gap-3" }
const _hoisted_13 = {
  key: 0,
  class: "list-none p-0 m-0 flex flex-column mt-3"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "col-10" }
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = { class: "booking-request-customer-name" }
const _hoisted_18 = { class: "notify-title" }
const _hoisted_19 = { class: "font-medium" }
const _hoisted_20 = { class: "mt-3 booking-detail-container" }
const _hoisted_21 = { class: "flex align-items-center gap-2 text-color-secondary ml-auto text-sm" }
const _hoisted_22 = {
  key: 1,
  class: "block text-center mt-8 ml-2"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "mr-2 ml-0 mb-0 font-normal text-white modal-title" }, "予約履歴", -1))
const _hoisted_24 = {
  key: 0,
  class: "loading"
}
const _hoisted_25 = {
  key: 1,
  class: "flex flex-column gap-3 w-35rem"
}
const _hoisted_26 = {
  key: 0,
  class: "list-none p-0 m-0 flex flex-column mt-3 notifications-container"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "col-8" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = {
  key: 0,
  class: "flex"
}
const _hoisted_31 = { class: "font-medium" }
const _hoisted_32 = {
  key: 1,
  class: "notify-title"
}
const _hoisted_33 = { class: "font-medium" }
const _hoisted_34 = { class: "mt-3" }
const _hoisted_35 = { class: "flex align-items-center gap-2 text-color-secondary ml-auto text-sm flex-column" }
const _hoisted_36 = {
  key: 1,
  class: "block text-center mt-8 ml-2"
}
const _hoisted_37 = {
  key: 2,
  class: "absolute w-full button-container cursor-pointer bottom-0"
}

import { ClinicService } from "@/clinic/services";
import { get, set } from "@vueuse/core";
import { IClinic, IClient } from "@/clinic/typings";
import { onBeforeMount, onMounted, onBeforeUnmount, ref, watch } from "vue";
import Dropdown, { DropdownChangeEvent } from "primevue/dropdown";
import RouterUtils from "@/common/utils/router.util";
import { AxiosResponse } from "axios";
import { useArrayFind } from "@vueuse/core";
import { DEFAULT_LOGO_URL } from "../typings/constants/clinic";
import { ClientLogOutOptionsEnum, ClientLogOutOptions } from "@/clinic/typings/enums/client";
import Badge from "primevue/badge";
import OverlayPanel from "primevue/overlaypanel";
import Avatar from "primevue/avatar";
import Tag from "primevue/tag";
import Sidebar from "primevue/sidebar";
import { createConsumer } from "@rails/actioncable";
import { useStore } from "vuex";
import RouterConstants from "../constants/router.constants";
import AppRouterConstants from "@/common/constants/app.constants";
import BookingNotificationsService from "../services/booking.notifications.service";
import { BookingServices } from "@/clinic/services";
import BookingSidebar from "@/clinic/views/Booking/booking-sidebar.vue";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { BookingViewPageTypeEnum, BookingViewTypeEnum } from "@/clinic/typings/enums/booking";
import ListBookingHistory from "@/clinic/views/Booking/components/list/list-booking-history.vue";
import ProgressSpinner from "primevue/progressspinner";
import { notifySuccesMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import router from "@/router";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

/**
 * Headerコンポーネント
 *
 * アプリのヘッダー部分を担当するコンポーネント
 * - クリニックの選択
 * - ログインユーザーのドロップダウンメニュー（ログアウトやアカウント設定）
 * - 通常予約通知・リクエスト予約通知の表示・閲覧
 * - 通知サイドバーから詳細・履歴を確認
 * などの機能を提供する
 *
 * @component
 */
const route = useRoute();
/** 予約通知サイドバーを参照するためのRef */
const showBookingSidebar = ref<InstanceType<typeof BookingSidebar> | null>(null);
/** BookingSidebarの表示状態フラグ */
const isShowDetail = ref(false);
/** カレンダー表示タイプ (Day / Week / Monthなど) */
const viewType = ref<string>(BookingViewTypeEnum.Day);

const toast = useToast();

/** 通常予約通知件数 */
const numBookingNormal = ref(0);
/** リクエスト予約通知件数 */
const numBookingRequest = ref(0);
/** 通常予約通知の一覧 */
const bookingNormal = ref();
/** リクエスト予約通知の一覧 */
const bookingRequest = ref();

/** 予約アラート用のサイドバー表示フラグ */
const visible = ref(false);
/** 通常予約履歴表示用のサイドバー表示フラグ */
const bookingNormalVisible = ref(false);

/** ActionCableのconsumerインスタンス */
const consumer = createConsumer(AppRouterConstants.WEBSOCKET_URL);

/** 通常・リクエスト予約データをロード中かどうか */
const isLoadingBookingNormal = ref(false);
const isLoadingBookingRequest = ref(false);

/** カレンダーコンポーネントのインスタンス（残枠数再取得用） */
const bookingCalendar = ref();

/** BookingHistoryコンポーネントのインスタンス（一覧再読み込み用） */
const listBookingHistory = ref<InstanceType<typeof ListBookingHistory> | null>(null);

/**
 * 予約履歴一覧をリロードする
 *
 * @function
 * @returns {void}
 */
const onReloadListBookingHistory = () => get(listBookingHistory)?.onLoadBooking();

/**
 * 残枠情報を再取得する
 *
 * @function
 * @returns {void}
 */
const reFetchRemainningSlot = () => {
  get(bookingCalendar)?.reFetchRemainningSlot();
};

/**
 * 予約画面へ遷移する
 *
 * @function
 * @returns {void}
 */
const redirectToBookingPage = () => {
  RouterUtils.goToWithQuery(RouterConstants.BOOKING_ROUTER_NAME, {
    view_page: BookingViewPageTypeEnum.StaffCalendar,
  });
};

/**
 * 予約通知を受け取るWebSocketチャネルを作成し、通知件数の更新を受け取る
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const createBookingNotificationsChannel = async () => {
  const clinicId = await store.dispatch("authClient/getClinicIdCookie");

  consumer.subscriptions.create(
    {
      channel: "ApplicationCable::BookingNotificationsChannel",
      clinic_id: clinicId,
    },
    {
      received(data) {
        if (data.clinic_id == clinicId) {
          if (data.notify_type == "normal" || data.notify_type == "repeat") {
            numBookingNormal.value = data.num_notify;
          } else {
            numBookingRequest.value = data.num_notify;
          }
        }
      },
    }
  );
};

/**
 * 予約アラート用サイドバーを閉じる処理
 *
 * @function
 * @returns {void}
 */
const onClose = () => {
  set(visible, false);
};

/**
 * リクエスト予約サイドバーを開くトグル処理
 * 予約リクエスト通知一覧を取得後、サイドバーを表示する
 *
 * @async
 * @function
 * @param {Event} event - クリックイベント等
 * @returns {Promise<void>}
 */
const toggle = async event => {
  await fetchBookingRequestNotifications();
  set(visible, true);
};

/**
 * 通常予約サイドバーを開くトグル処理
 * 通常予約通知一覧を取得後、サイドバーを表示する
 *
 * @async
 * @function
 * @param {Event} event - クリックイベント等
 * @returns {Promise<void>}
 */
const toggleBookingNormal = async event => {
  await fetchBookingNormalNotifications();
  set(bookingNormalVisible, true);
};

const store = useStore();

/**
 * 現在選択されているクリニック情報
 *
 * @type {import("@/clinic/typings").IClinic}
 */
const selectedClinic = ref<IClinic>({
  id: 0,
  name: "",
  address: "",
  tel: "",
  remark: "",
  client_id: 0,
  logo_url: DEFAULT_LOGO_URL,
});

/** 選択可能なクリニック一覧 */
const listClinics = ref<IClinic[]>([]);

/**
 * クリニックドロップダウン選択時のイベントハンドラ
 *
 * @async
 * @function
 * @param {DropdownChangeEvent} param - ドロップダウンのchangeイベント
 * @returns {Promise<void>}
 */
const onSelect = async ({ value: clinic }: DropdownChangeEvent) => {
  setClinic(clinic);
  await createBookingNotificationsChannel();
  await fetchTotalNotify();
};

/**
 * 選択されたクリニックをストアへ反映し、クッキーにも保存する
 *
 * @function
 * @param {import("@/clinic/typings").IClinic} clinic - 選択したクリニックオブジェクト
 * @returns {void}
 */
const setClinic = (clinic: IClinic) => {
  set(selectedClinic, clinic);
  store.commit("authClient/setClinic", clinic);
  store.dispatch("authClient/saveClinicCookie", clinic);
};

/**
 * クッキーから取得したクリニックIDを元に、クリニックを選択状態にする
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const loadClinic = async () => {
  const clinicId = await store.dispatch("authClient/getClinicIdCookie");
  let clinic = useArrayFind(listClinics, clinic => clinic.id == clinicId);
  if (!get(clinic)?.id) clinic = get(store.getters["authClient/firstClinic"]); // first clinic
  setClinic(get(clinic) as IClinic);
};

/**
 * ログアウト・アカウント設定などのドロップダウン選択ハンドラ
 *
 * @function
 * @param {DropdownChangeEvent} param - 選択されたオプション
 * @returns {void}
 */
const changingLogOutOption = ({ value: selectedOption }: DropdownChangeEvent) => {
  switch (selectedOption) {
    case ClientLogOutOptionsEnum.log_out:
      logOut();
      break;
    case ClientLogOutOptionsEnum.account_settings:
      RouterUtils.goTo(RouterConstants.CLIENT_DETAILS_ROUTER_NAME);
      break;
    case ClientLogOutOptionsEnum.privacy_policy:
      RouterUtils.goTo(RouterConstants.PRIVACY_POLICY_ROUTER_NAME);
      break;
    case ClientLogOutOptionsEnum.company_profile:
      RouterUtils.goTo(RouterConstants.COMPANY_PROFILE_ROUTER_NAME);
      break;
    case ClientLogOutOptionsEnum.terms_of_service:
      RouterUtils.goTo(RouterConstants.TERMS_OF_SERVICE_ROUTER_NAME);
      break;
    case ClientLogOutOptionsEnum.manual:
      window.open("https://re-coma.net/manual/", "_blank");
      break;
    default:
      return;
  }
};

/**
 * ログアウト処理
 *
 * @function
 * @returns {void}
 */
const logOut = () => {
  store.dispatch("authClient/removeAccessTokenCookie");
  RouterUtils.goTo(RouterConstants.SIGN_IN_ROUTER_NAME);
};

/**
 * 予約通知一覧ページ（通常）へ遷移
 *
 * @function
 * @returns {void}
 */
const listBookingNotifications = () => {
  RouterUtils.goTo(RouterConstants.BOOKING_NOTIFICATIONS_ROUTE_NAME);
};

/**
 * 通常予約の通知一覧を取得し、サイドバーに表示する
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const fetchBookingNormalNotifications = async () => {
  try {
    set(isLoadingBookingNormal, true);
    const clinicId = await store.dispatch("authClient/getClinicIdCookie");
    const maximumNormalNotify = 20;
    const params = {
      clinic_id: clinicId,
      notification_type: ["normal", "repeat"],
      sort_column: "created_at",
      sort_order: "desc",
      limit: maximumNormalNotify,
    };
    const response = await BookingNotificationsService.fetch(params);
    set(bookingNormal, response.data.value.booking_notifications);
    set(isLoadingBookingNormal, false);
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * リクエスト予約の通知一覧を取得し、サイドバーに表示する
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const fetchBookingRequestNotifications = async () => {
  try {
    const clinicId = await store.dispatch("authClient/getClinicIdCookie");
    const params = {
      clinic_id: clinicId,
      notification_type: "request",
      sort_column: "created_at",
      sort_order: "desc",
    };
    const response = await BookingNotificationsService.fetch(params);
    set(bookingRequest, response.data.value.booking_notifications);
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * 通常・リクエスト通知の未読件数を取得して反映する
 *
 * @async
 * @function
 * @returns {Promise<void>}
 */
const fetchTotalNotify = async () => {
  try {
    const clinicId = await store.dispatch("authClient/getClinicIdCookie");
    const params = { clinic_id: clinicId };
    const response = await BookingNotificationsService.count(params);
    set(numBookingNormal, response.data.value.total_normal);
    set(numBookingRequest, response.data.value.total_request);
  } catch (error) {
    console.log("error", error);
  }
};

/**
 * 通知をクリックした際に、該当予約の詳細を取得し表示する
 * 通常通知の場合は既読状態に更新した後、再度未読件数を取得する
 *
 * @async
 * @function
 * @param {Object} notify - クリックされた通知情報
 * @returns {Promise<void>}
 */
const fetchBookingDetail = async (notify: any) => {
  try {
    if (notify.notification_type == "normal") {
      notify.viewed = true;
    }
    const clinicId = await store.dispatch("authClient/getClinicIdCookie");
    const notifyParams = { clinic_id: clinicId, viewed: true };
    if (notify.notification_type == "normal") {
      await BookingNotificationsService.update(notify.id, notifyParams);
      fetchTotalNotify();
    }
    const params = { clinic_id: clinicId };
    const id = notify.booking_id;
    const response = await BookingServices.getBooking({ id, ...params });
    const booking = response.data.value;

    if (!booking) {
      notityErrorMsg(toast, "予約はすでに削除されています");
      return;
    }

    let bookingStartTime = booking["start_time"];
    if (booking.booking_type == "request") {
      bookingStartTime = booking.booking_requests[0]["start_time"];
    }

    const storeValues = {
      start_time: bookingStartTime,
      booking_id: booking["id"],
    };
    store.commit("booking/setHeaderBookingDetails", storeValues);
    if (route.name != RouterConstants.BOOKING_ROUTER_NAME) {
      set(bookingNormalVisible, false);
      router.push({ name: RouterConstants.BOOKING_ROUTER_NAME, query: storeValues });
    }
  } catch (error) {
    console.log("error", error);
    notityErrorMsg(toast, "予約はすでに削除されています");
    set(isLoadingBookingNormal, false);
  }
};

/**
 * 通常予約通知のアクション種別に対する背景色を設定するマップを返却する
 *
 * @function
 * @returns {Object} キーがアクション種別、値がCSSクラス名のオブジェクト
 */
const bookingNormalBackgroundColor = () => {
  return {
    create_booking: "bg-will-come",
    update_booking: "bg-booked",
    update_booking_status: "bg-booked",
    customer_cancel_booking: "bg-cancel",
    admin_cancel_booking: "bg-cancel",
    admin_destroy_booking: "bg-visited",
    admin_confirm_request: "bg-booking-request",
    create_routine_booking: "bg-cancel-not-notice",
    update_routine_booking: "bg-booking-instagram",
  };
};

/**
 * 通知内の予約詳細確認処理をVuexの状態を通じて呼び出した場合に、実際に詳細表示を行うwatch処理
 * 予約が存在する場合はBookingSidebarを表示し、存在しない場合はエラー通知をおこなう
 */
watch(
  () => store.state.booking.notificationsBookingDetails,
  async (newValue, oldValue) => {
    const id = newValue["booking_id"];
    const clinicId = await store.dispatch("authClient/getClinicIdCookie");
    const notifyId = newValue["notification_id"];
    const notifyParams = { clinic_id: clinicId, viewed: true };
    const params = { clinic_id: clinicId };
    try {
      const response = await BookingServices.getBooking({ id, ...params });
      const booking = response.data.value;
      if (!booking) {
        notityErrorMsg(toast, "予約はすでに削除されています");
      } else {
        get(showBookingSidebar)?.onShow(booking, "ShowBooking", event);
        set(isShowDetail, true);
      }
      await BookingNotificationsService.update(notifyId, notifyParams);
      await fetchTotalNotify();
    } catch (error) {
      notityErrorMsg(toast, "予約はすでに削除されています");
    }
  }
);

/**
 * REFRESH_NOTIFY_COUNTイベントを受け取って通知件数を再取得する
 * このイベントは外部モジュールから発火されることを想定している
 *
 * @function
 * @returns {void}
 */
const onRefreshCount = () => {
  fetchTotalNotify();
};

/**
 * リクエスト予約の更新をstore側で検知し、再度通知一覧を取得する
 */
watch(
  () => store.state.booking.notificationsBookingRequests,
  (newValue, oldValue) => {
    if (newValue) {
      fetchBookingRequestNotifications();
    }
  }
);

/**
 * コンポーネントがマウント前に呼ばれるフック
 * クリニックのロード、通知チャンネルの作成、通知件数取得をおこなう
 */
onBeforeMount(async () => {
  const { data: client } = (await ClinicService.client()) as unknown as AxiosResponse<IClient>;
  store.commit("authClient/setClient", client);
  set(listClinics, store.getters["authClient/clinics"]);

  await loadClinic();
  await createBookingNotificationsChannel();
  await fetchTotalNotify();
});

/**
 * コンポーネントがマウントされたときのフック
 * REFRESH_NOTIFY_COUNTイベントのリスナーを登録し、外部モジュールからの通知件数更新を受け取る
 */
onMounted(() => {
  window.addEventListener("REFRESH_NOTIFY_COUNT", onRefreshCount);
});

/**
 * コンポーネントがアンマウントされる直前に呼ばれるフック
 * REFRESH_NOTIFY_COUNT イベントリスナーを解除し、メモリリークや重複リスナーを防止する
 */
onBeforeUnmount(() => {
  window.removeEventListener("REFRESH_NOTIFY_COUNT", onRefreshCount);
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", {
          class: "header-logo cursor-pointer",
          onClick: redirectToBookingPage
        }, _hoisted_4),
        _createVNode(_unref(Dropdown), {
          modelValue: selectedClinic.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedClinic).value = $event)),
          options: listClinics.value,
          optionLabel: "name",
          placeholder: "店舗名",
          emptyMessage: "紐づけられた店舗情報がございません",
          class: "w-full md:w-14rem header-clinic-dropdowns",
          onChange: onSelect
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Button, {
          type: "button",
          class: "notify-icon ml-2 mr-2 bg-booking-alert",
          onClick: toggle
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["svg-icon booking-request-icon", { 'mr-2': numBookingRequest.value == 0 }]),
              style: {"width":"1.2em","height":"1.7em","vertical-align":"middle","fill":"currentColor","overflow":"hidden"},
              viewBox: "0 0 1024 1024",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_7, 2)),
            (numBookingRequest.value > 0)
              ? (_openBlock(), _createBlock(_unref(Badge), {
                  key: 0,
                  value: numBookingRequest.value,
                  severity: "danger",
                  class: "num-notify"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _createTextVNode(" 予約アラート ")
          ]),
          _: 1
        }),
        _createVNode(_component_Button, {
          type: "button",
          class: "notify-icon bg-normal-booking",
          onClick: toggleBookingNormal
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("svg", {
              class: _normalizeClass(["svg-icon", { 'mr-2': numBookingNormal.value == 0 }]),
              style: {"width":"1.5em","height":"1.7em","vertical-align":"middle","fill":"currentColor","overflow":"hidden"},
              viewBox: "0 0 1024 1024",
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg"
            }, _hoisted_9, 2)),
            (numBookingNormal.value > 0)
              ? (_openBlock(), _createBlock(_unref(Badge), {
                  key: 0,
                  value: numBookingNormal.value,
                  severity: "danger",
                  class: "num-booking-normal-notify"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true),
            _createTextVNode(" 予約履歴 ")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(Dropdown), {
            class: "border-none shadow-none account-dropdown",
            options: _unref(ClientLogOutOptions),
            optionLabel: "value",
            optionValue: "value",
            dropdownIcon: "pi pi-user text-2xl text-700",
            onChange: changingLogOutOption
          }, null, 8, ["options"])
        ]),
        (isShowDetail.value)
          ? (_openBlock(), _createBlock(BookingSidebar, {
              key: 0,
              ref_key: "showBookingSidebar",
              ref: showBookingSidebar,
              toast: _unref(toast),
              viewType: viewType.value,
              onReloadListBookingHistory: onReloadListBookingHistory,
              reFetchRemainningSlot: reFetchRemainningSlot
            }, null, 8, ["toast", "viewType"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(Sidebar), {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
        onHide: onClose,
        position: "right",
        class: "booking-normal-sidebar w-full w-30rem"
      }, {
        header: _withCtx(() => [
          _hoisted_11
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              (bookingRequest.value.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingRequest.value, (notify) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: notify.id,
                        class: "flex align-items-center border-b border-gray-300 notify-detail cursor-pointer",
                        onClick: ($event: any) => (fetchBookingDetail(notify))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            (notify.booking_source == 'hotpepper')
                              ? (_openBlock(), _createBlock(_unref(Avatar), {
                                  key: 0,
                                  class: "booking-source-logo mb-2 booking-source mr-2",
                                  image: "/images/hotpepper-icon.ico",
                                  shape: "circle"
                                }))
                              : (notify.booking_source == 'line')
                                ? (_openBlock(), _createBlock(_unref(Avatar), {
                                    key: 1,
                                    class: "booking-source-logo mb-2 booking-source mr-2",
                                    image: "/images/icon_line.png",
                                    shape: "circle"
                                  }))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["inline-block customer-status border-round-xl text-center mr-1 px-2", notify.customer_status])
                              }, _toDisplayString(notify.customer_status_name), 3)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(notify.title), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notify.booking_info, (info, index) => {
                              return (_openBlock(), _createBlock(_unref(Tag), {
                                key: index,
                                class: _normalizeClass(["mr-2 booking-detail mt-2", notify.viewed ? 'bg-viewed' : '']),
                                value: "Contrast"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(info), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("span", null, _toDisplayString(notify.diff_current_date_time), 1)
                        ])
                      ], 8, _hoisted_14))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, "アラートはありません。"))
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      _createVNode(_unref(Sidebar), {
        visible: bookingNormalVisible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((bookingNormalVisible).value = $event)),
        onHide: onClose,
        position: "right",
        class: "booking-normal-sidebar w-full w-30rem"
      }, {
        header: _withCtx(() => [
          _hoisted_23
        ]),
        default: _withCtx(() => [
          (isLoadingBookingNormal.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_unref(ProgressSpinner), {
                  class: "loading-icon",
                  strokeWidth: "3",
                  animationDuration: ".5s"
                })
              ]))
            : _createCommentVNode("", true),
          (!isLoadingBookingNormal.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  (bookingNormal.value.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookingNormal.value, (notify) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: notify.id,
                            class: _normalizeClass(["flex align-items-center gap-2 border-b border-gray-300 notify-detail cursor-pointer", notify.viewed ? 'bg-viewed' : '']),
                            onClick: ($event: any) => (fetchBookingDetail(notify))
                          }, [
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                (notify.owner == 'customer')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["inline-block customer-status booking-normal-customer border-round-xl text-center mr-1 px-2", notify.customer_status])
                                      }, _toDisplayString(notify.customer_status_name), 3),
                                      _createElementVNode("span", _hoisted_31, _toDisplayString(notify.title), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                      _createElementVNode("span", _hoisted_33, _toDisplayString(notify.title), 1)
                                    ]))
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notify.booking_info, (info, index) => {
                                  return (_openBlock(), _createBlock(_unref(Tag), {
                                    key: index,
                                    class: _normalizeClass(["mr-2 booking-detail mt-2", notify.viewed ? 'bg-viewed' : '']),
                                    value: "Contrast"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(info), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["class"]))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("span", null, _toDisplayString(notify.diff_current_date_time), 1),
                              _createVNode(_unref(Tag), {
                                class: _normalizeClass(["booking-detail border-none", bookingNormalBackgroundColor()[notify.action_type]]),
                                value: "Contrast"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(notify.action_type_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["class"])
                            ])
                          ], 10, _hoisted_27))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, "表示できる履歴はありません。"))
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoadingBookingNormal.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _createVNode(_component_Button, {
                  label: "その他予約履歴情報を見る",
                  class: "p-button w-full",
                  onClick: listBookingNotifications
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})